import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import api from '../../utils/api/axiosInstance';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const RevenueComparisonChart = () => {
    const [reports, setReports] = useState([]);

    const getReport = async () => {
        try {
            const response = await api.post('/reports/general/sales');
            setReports(response.data);
        } catch (error) {
            console.error(error.message || "Request failed");
        }
    };

    useEffect(() => {
        getReport();
    }, []);

    const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const monthlySales2023 = new Array(12).fill(0);
    const monthlySales2024 = new Array(12).fill(0);

    reports?.general_sales_reports?.monthlySales?.forEach((sale) => {
        const [year, month] = sale.month.split('-');
        const monthIndex = parseInt(month, 10) - 1;

        if (year === '2023') {
            monthlySales2023[monthIndex] = parseFloat(sale.totalSales);
        } else if (year === '2024') {
            monthlySales2024[monthIndex] = parseFloat(sale.totalSales);
        }
    });

    const data = {
        labels,
        datasets: [
            {
                label: '2023 Revenue',
                data: monthlySales2023,
                borderColor: '#fbbf24',
                backgroundColor: 'transparent',
                borderWidth: 2,
                fill: false,
                tension: 0.4,
                pointRadius: 0.2,
            },
            {
                label: '2024 Revenue',
                data: monthlySales2024,
                borderColor: '#4ade80',
                borderWidth: 2,
                fill: false,
                tension: 0.4,
                pointRadius: 0.2,
            }
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
            },
        },
        scales: {
            x: {
                ticks: {
                    color: '#000',
                },
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                    color: '#000',
                },
                grid: {
                    borderDash: [5, 5],
                    color: '#f8f8f8',
                },
            },
        },
    };

    return (
        <div className="border border-gray-200 p-6 rounded-lg w-full">
            <h2 className="text-xl font-bold mb-4">Revenue Comparison</h2>
            <Line data={data} options={options} />
        </div>
    );
};

export default RevenueComparisonChart;
